import { render, staticRenderFns } from "./modal-sendmessage.vue?vue&type=template&id=df3e49fe&"
import script from "./modal-sendmessage.vue?vue&type=script&lang=js&"
export * from "./modal-sendmessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports